var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewContactIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.235,
    height: 11,
    viewBox: "0 0 14.235 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-import-contacts",
    "data-name": "Icon material-import-contacts",
    d: "M14.441,7.074a7.638,7.638,0,0,0-2.265-.324,6.018,6.018,0,0,0-3.559.971A6.018,6.018,0,0,0,5.059,6.75,6.018,6.018,0,0,0,1.5,7.721V17.2a.348.348,0,0,0,.324.324c.065,0,.1-.032.162-.032a7.9,7.9,0,0,1,3.074-.712,6.018,6.018,0,0,1,3.559.971,7.794,7.794,0,0,1,3.559-.971,6.586,6.586,0,0,1,3.074.679.292.292,0,0,0,.162.032.348.348,0,0,0,.324-.324V7.721A4.413,4.413,0,0,0,14.441,7.074Zm0,8.735a7.519,7.519,0,0,0-2.265-.324,7.794,7.794,0,0,0-3.559.971V9.015a7.794,7.794,0,0,1,3.559-.971,7.519,7.519,0,0,1,2.265.324Z",
    transform: "translate(-1.5 -6.75)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewContactIco);
export default __webpack_public_path__ + "static/media/new-contact-ico.cbaad390.svg";
export { ForwardRef as ReactComponent };